// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a805b571","80":"9954553d","358":"2bc1bfc3","496":"f8cef6ba","748":"4e82a405","763":"6ecc49f4","835":"7fc7fed7","926":"9161c4e2"}[chunkId] + ".chunk.js";
};